// src/composables/useFilePreview.ts
import { useQuasar } from 'quasar'
import { ref } from 'vue'

export function useFilePreview() {
  const $q = useQuasar()
  const previewDialog = ref(false)
  const iframeUrl = ref<string | null>(null)
  const activeBlobUrl = ref<string | null>(null)

  function openFile(url: string) {
    if ($q.platform.is.mobile) {
      window.open(url, '_blank')
    } else {
      iframeUrl.value = url
      previewDialog.value = true
    }
  }

  function closePreview() {
    previewDialog.value = false
    iframeUrl.value = null
  }

  function openBlob(blob: Blob | File) {
    cleanup() // Καθαρίζουμε προηγούμενο blob

    const url = URL.createObjectURL(blob)
    activeBlobUrl.value = url

    if ($q.platform.is.mobile) {
      window.open(url, '_blank')
      setTimeout(() => cleanup(), 60000)
    } else {
      iframeUrl.value = url
      previewDialog.value = true
    }
  }

  function cleanup() {
    if (activeBlobUrl.value) {
      URL.revokeObjectURL(activeBlobUrl.value)
      activeBlobUrl.value = null
    }
    iframeUrl.value = null
  }

  return {
    previewDialog,
    iframeUrl,
    openFile,
    closePreview,
    openBlob,
  }
}
